import axiosRoot from "../../axios/axiosRoot";
import axios from "../../axios/axios";

export const pegaSessao = ({ commit }) => {
    commit("setLoading", true);

    return axiosRoot
    .post("publico/controller/listarSessao.php")
    .then(resp => {
        if (resp.data.status == false) window.location.href = "/login";
        commit("setLoading", false)
        commit("setUsuario", resp.data)
    })
    .catch(error => {
        commit("setLoading", false);
    });
};

export const verificaSessao = ({ commit }) => {
    return axiosRoot
    .post("publico/controller/listarSessao.php")
    .then(resp => {
        if (resp.data.status == false) window.location.href = "/login";
    })
};

export const navbar = ({ commit }) => {
    return axios
    .post("listarMenuPrincipal.php")
    .then(resp => {
        if (resp.data.status == true) commit("setNavbar", resp.data.dados)
    })
    .catch(error => {
        console.error(error)
    });
};